import { createApp } from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import confirm from './plugins/confirm'
import { registerServiceWorker } from './services/pwaService'
import { describeError, isErrorNotified, markErrorNotified } from './helpers/errorMessages'

import 'bootstrap/js/dist/dropdown'
import 'jodit/build/jodit.min.css'

window.$ = window.jQuery = require('jquery')

// Глобальная страховка: ошибка, которую не перехватил ни один store-action
// и ни один редактор, попадает в уведомления, а не только в консоль.
// Ошибки, уже показанные store (см. helpers/errorMessages.js), второй раз
// не показываются, только логируются.
let lastReportedKey = ''
let lastReportedAt = 0

function reportUnexpectedError(error, source) {
  if (isErrorNotified(error)) {
    // eslint-disable-next-line no-console
    console.warn(`[${source}] ошибка уже показана пользователю`, error)
    return
  }
  // eslint-disable-next-line no-console
  console.error(`[${source}]`, error)
  markErrorNotified(error)

  const notification = describeError(error, 'Что-то пошло не так')
  // Один и тот же сбой в цикле рендера не должен превращаться в поток уведомлений.
  const key = `${notification.title}|${notification.message}`
  const now = Date.now()
  if (key === lastReportedKey && now - lastReportedAt < 3000) return
  lastReportedKey = key
  lastReportedAt = now

  store.dispatch('notify', { ...notification, duration: 8000 })
}

window.addEventListener('unhandledrejection', event => {
  event.preventDefault()
  reportUnexpectedError(event.reason, 'unhandledrejection')
})

store.dispatch('initAuth')
  .finally(() => {
    const app = createApp(App)
      .use(router)
      .use(store)
      .use(confirm)

    app.config.errorHandler = (error, instance, info) => {
      reportUnexpectedError(error, `vue:${info}`)
    }

    app.mount('#app')

    registerServiceWorker()
  })
